import { Injectable } from '@angular/core';

import { NavController } from '@ionic/angular';
import { ActivationService } from './activation.service';
import { CanActivateFn, UrlTree } from '@angular/router';

/**
 * #deprecated
 * In Angular 16+, CanActivate, CanDeactivate, etc. are technically deprecated, but they still work just fine.
 * will move to functional guards in angular 18 migration
 */
@Injectable({
  providedIn: 'root',
})
export class ActivationPageGuardService {
  constructor(private activationService: ActivationService, private navCtrl: NavController) {}
  canActivate: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const activationStatus = await this.activationService.isActivated();
    switch (activationStatus) {
      case 'ACTIVATION_REQUIRED':
        return true;
      case 'ACTIVATED_APP_INSTALLED':
        this.navCtrl.navigateRoot(['/app-landing']);
        return false;
      default:
        return false;
    }
  };
}
